import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import { HTTP } from "./../helpers/http-common"

Vue.use(VueRouter)

const routes = [
 
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  
  {
    path: '/login',
    name: 'Login',
    component: () => import('../components/Login.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/admin',
    name: 'Admin',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin.vue')
  },
  
  {
    path: '/healthcheck',
    name: 'HealthCheck',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/HealthCheck.vue')
  },
  {
    path: '/allnotification',
    name: 'Allnotification',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Allnotification.vue')
  },

  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// router.beforeEach((to, from, next) => {
//   // redirect to login page if not logged in and trying to access a restricted page
//   const publicPages = ['/login', '/about', '/admin'];
//   const authRequired = !publicPages.includes(to.path);
//   const loggedIn = sessionStorage.getItem('userId');

//   if (authRequired && !loggedIn) {
//     return next('/login');
//   }

//   next();
// })

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = sessionStorage.getItem('userId');
  const bearerToken = sessionStorage.getItem('bearerToken');
  if (bearerToken) {
    HTTP.defaults.headers.common['Authorization'] = `Bearer ${bearerToken}`;
  }

  if (authRequired && !loggedIn && !bearerToken) {
    return next('/login');
  }

  next();
})


export default router
